import { useParams } from 'react-router-dom';

import { AppCreateLegalDocumentPage } from '~/components/pages/AppCreateLegalDocumentPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppCreateLegalDocumentRoute: React.FC = () => {
  const { appId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppCreateLegalDocumentPage appId={appId} />
    </DashboardTemplate>
  );
};
